import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Table, Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { CustomBtn } from "../../../../components/Button";
import { PinCodeDialog } from "../../../../components/Dialog/pincode-dialog";
import { getFeesAsync } from "../../../../redux/fees/fees-slice";
import { billRapidoAsync, billrapidoClearState } from "../../../../redux/bills/bill-rapido-slice";
import { getTransactionAsync, transactionClearState } from "../../../../redux/transaction/transaction-slice";
import { API_ROOT } from "../../../../utils/api-config";
import { useBillBaloonInputProcessMutation, useBillBaloonSimulationMutation, useBillBaloonInputSaveMutation, useBillBaloonPricingRequestMutation } from "../../service/bill-api";
import { renderFormItem } from "../../../../utils/render-form-item";
import { InputNumber, Select, DatePicker } from 'antd';
import moment from 'moment';
import Step1modal from "./step-1-page";

export function BillBaloonPage() {
    const dispatch = useDispatch();
    const { currentAgent } = useSelector((state) => state.auth);
    const [form] = Form.useForm();
    const dialog = useSelector((state) => state.dialog);
    const frais = useSelector((state) => state.fees);
    const [inputProcess, setInputProcess] = useState();
    const [inputPricing, setInputPricing] = useState();
    const [billBaloonSimulation] = useBillBaloonSimulationMutation();
    const [billBaloonInputProcess] = useBillBaloonInputProcessMutation();
    const [billBaloonInputSave] = useBillBaloonInputSaveMutation();
    const [billBaloonPricingRequest] = useBillBaloonPricingRequestMutation();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [simulationId, setSimulationId] = useState("");
    const [showSimulation, setShowSimulation] = useState(true);
    const [pageCode, setPageCode] = useState("");
    const [usageVehicule, setUsageVehicule] = useState("");
    const [data, setData] = useState({ inputs: [] });
    const [selectedData, setSelectedData] = useState({ inputs: [] });
    const billRapido = useSelector((state) => state.billRapido);
    const [montant, setMontant] = useState("");
    const [phone, setPhone] = useState("")
    const [numrapido, setNumrapido] = useState("")
    const transaction = useSelector((state) => state.transaction);

    const handleGetSimulation = async () => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": "",
            "country": currentAgent.country,
            "token": currentAgent.access_token
        }
        billBaloonSimulation(data)
            .unwrap()
            .then((res) => {
                setSimulationId(res.simulation_id);
                handleInputProcess(res.simulation_id);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    }


    const handleInputProcess = async (simulationId) => {
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": "",
            "country": currentAgent.country,
            "simulation_id": simulationId,
            "step": "NimbaAutoSN02",
            "token": currentAgent.access_token
        }
        billBaloonInputProcess(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setPageCode(res.page_code);
                setInputProcess(res);
                setShowSimulation(false);
                setIsModalOpen(true);
            })
            .catch((error) => {
                setIsLoading(false);
                // setError(error.data.error);
            });
    }


    const handleInputProcessSave = async (values) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": "",
            "country": currentAgent.country,
            "token": currentAgent.access_token,
            "inputs": selectedData.inputs,
            "simulation_id": simulationId,
            "page_code": pageCode,
        }
        billBaloonInputSave(data)
            .unwrap()
            .then((res) => {
                setInputPricing(res);
                setInputProcess()
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                // setError(error.data.error);
            });
    }

    const handlePricingRequest = async (values) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": "",
            "country": currentAgent.country,
            "token": currentAgent.access_token,
            "simulation_id": simulationId,
        }
        billBaloonPricingRequest(data)
            .unwrap()
            .then((res) => {
                setInputPricing('');
                console.log("res", res);
                // setInputPricing(res);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                // setError(error.data.error);
            });
    }



    const handleChange = (input_name, value) => {
        setSelectedData((prev) => {
            const filtered = prev.inputs.filter((item) => item.input_name !== input_name);
            return {
                inputs: [...filtered, { input_name, values: [value] }],
            };
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        // Ajoutez ici la logique à exécuter lors du clic sur OK
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        // Ajoutez ici la logique à exécuter lors du clic sur Annuler
        setIsModalOpen(false);
    };


    return (
        <div className="default-page" >
            <PageHeader title="Baloon Assurance" />

            {/* <Button type="primary" onClick={showModal}>
                Open Modal from Parent
            </Button> */}
            <Step1modal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
            />

            <Spin tip="Chargement..." spinning={isLoading || frais.isFetching || billRapido.isFetching || billRapido.isFetching}>
                <Card className="card">
                    {
                        showSimulation &&
                        <div className="simulation">
                            <h2 className="text-center">Votre assurance auto en 2 minutes</h2>
                            <p className="text-center">Bénéficiez des meilleurs offres grâce à notre partenaire assureur Baloon, le courtier leader qui rend l'assurance plus accessible en Sénégal et en</p>
                            <Button className="btn btn-secondary" target="_blank" rel="noopener noreferrer" onClick={() => handleGetSimulation()}>Démarrer le devis</Button>
                            <br /><br /><br />
                        </div>
                    }

                    {inputProcess &&
                        <Form form={form} layout="vertical" onFinish={handleInputProcessSave}>
                            <h2>{inputProcess?.title}</h2>
                            {inputProcess?.inputs.map((field) => renderFormItem(field, handleChange))}
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Valider 1
                                </Button>
                            </Form.Item>
                        </Form>
                    }
                    <br /><br />
                    {inputPricing &&
                        <Form form={form} layout="vertical" onFinish={handlePricingRequest}>
                            <h2>{inputPricing?.title}</h2>
                            {inputPricing?.inputs.map((field) => renderFormItem(field, handleChange))}
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Valider 2
                                </Button>
                            </Form.Item>
                        </Form>
                    }

                </Card>
                {/* <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Form
                                name="basic"
                                form={form}
                                layout="vertical"
                                initialValues={{ remember: true }}
                                onFinish={handleFees}
                            >

                                <Form.Item
                                    label="Numéro du client"
                                    name="costumer_number"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero du client"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Numero de la carte rapido"
                                    name="rapido_number"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero de la carte rapido"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Montant"
                                    name="montant"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]} >
                                    <Input
                                        className="form-control"
                                        placeholder="Montant" />
                                </Form.Item>

                                <Form.Item>
                                    <CustomBtn title="Valider" />
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Table
                                dataSource={transaction.data}
                                locale={{
                                    emptyText: (transaction.data) ?
                                        null
                                        : (
                                            <Button
                                                onClick={() => handleTransaction()}
                                                size="large"
                                                className="btn btn-secondary">
                                                {"Afficher l'historique des transactions"}
                                            </Button>
                                        )
                                }}
                                loading={transaction.isFetching}
                                columns={columns} />
                        </Card>
                    </Col>
                </Row> */}
            </Spin>
        </div>
    );
}
export default BillBaloonPage;
